/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';

const { lPink } = colors;

const EmptyBtn = ({
  label,
  tabIndex = null,
  ariaLabel = '',
  disabled,
  onClick,
  style = {},
  children,
  ...props
}: {
  label?: string;
  tabIndex?: any;
  ariaLabel?: string;
  disabled?: boolean;
  style?: {};
  onClick?: any;
  children: any;
}) => {
  //

  return (
    <button
      css={css`
        padding: 0;
        border: none;
        font: inherit;
        color: inherit;
        background-color: transparent;
        cursor: pointer;
        &:focus-visible {
          outline: 1px solid ${lPink};
          outline-offset: 3px;
        }
      `}
      style={style}
      {...props}
      disabled={disabled}
      onClick={onClick}
      tab-index={tabIndex}
      aria-label={ariaLabel}
    >
      {children || label}
    </button>
  );
};

export default EmptyBtn;
